import React from "react";

export const SchedulePicker = ({
    dueDate,
    setDueDate,
    dueTime,
    setDueTime,
    isRecurring,
    setIsRecurring,
    recurrenceType,
    setRecurrenceType,
    recurrenceDays,
    setRecurrenceDays,
    showSchedule,
    setShowSchedule,
    scheduleRef
}) => {
    const daysOfWeek = [
        { id: 1, label: "L" }, { id: 2, label: "M" }, { id: 3, label: "X" },
        { id: 4, label: "J" }, { id: 5, label: "V" }, { id: 6, label: "S" }, { id: 0, label: "D" }
    ];

    const toggleDay = (dayId) => {
        setRecurrenceDays(prev =>
            prev.includes(dayId) ? prev.filter(d => d !== dayId) : [...prev, dayId]
        );
    };

    // Determinar si la fecha/hora ha sido configurada o modificada
    const isConfigured = Boolean(dueDate || dueTime || isRecurring);

    // Formatear la etiqueta de la fecha de forma legible
    const getScheduleLabel = () => {
        if (!dueDate && !dueTime && !isRecurring) return "Planificar";

        let label = "";
        const todayStr = new Date().toISOString().split("T")[0];
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        const tomorrowStr = tomorrow.toISOString().split("T")[0];

        if (dueDate === todayStr) {
            label = "Hoy";
        } else if (dueDate === tomorrowStr) {
            label = "Mañana";
        } else if (dueDate) {
            label = dueDate;
        } else {
            label = "Planificado";
        }

        if (dueTime) {
            label += ` ${dueTime.slice(0, 5)}`;
        }

        if (isRecurring) {
            label += " 🔁";
        }

        return label;
    };

    return (
        <div className="relative" ref={scheduleRef}>
            <button
                type="button"
                onClick={() => setShowSchedule(!showSchedule)}
                className={`px-2.5 py-1.5 rounded-lg border text-xs font-medium flex items-center space-x-1.5 transition-all duration-200
                    ${isConfigured 
                        ? "bg-emerald-50 border-emerald-300 text-emerald-800 font-semibold shadow-sm" 
                        : showSchedule 
                            ? "bg-emerald-50/50 border-emerald-200 text-emerald-700" 
                            : "bg-white border-gray-200 text-gray-600 hover:bg-gray-50"
                    }`}
            >
                <i className={`${isConfigured ? "fas fa-calendar-check text-emerald-600" : "far fa-calendar-alt text-gray-400"} text-sm transition-colors`}></i>
                <span>{getScheduleLabel()}</span>
                {isConfigured && (
                    <i className="fas fa-check text-[9px] bg-emerald-600 text-white rounded-full w-3.5 h-3.5 flex items-center justify-center ml-0.5 animate-fadeIn"></i>
                )}
            </button>

            {showSchedule && (
                <div className="absolute left-0 top-full mt-2 p-3 bg-white border border-gray-200 rounded-lg shadow-xl z-50 w-64 space-y-3 animate-fadeIn">
                    <div>
                        <label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Fecha límite</label>
                        <input
                            type="date"
                            value={dueDate}
                            onChange={(e) => setDueDate(e.target.value)}
                            className="w-full p-1.5 border border-gray-200 rounded text-xs text-gray-700 focus:outline-none"
                        />
                    </div>
                    <div>
                        <label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Hora (Opcional)</label>
                        <input
                            type="time"
                            value={dueTime}
                            onChange={(e) => setDueTime(e.target.value)}
                            className="w-full p-1.5 border border-gray-200 rounded text-xs text-gray-700 focus:outline-none"
                        />
                    </div>
                    <div className="pt-2 border-t border-gray-100">
                        <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                                type="checkbox"
                                checked={isRecurring}
                                onChange={(e) => setIsRecurring(e.target.checked)}
                                className="rounded border-gray-300 text-blue-600 focus:ring-blue-500 w-3.5 h-3.5"
                            />
                            <span className="text-xs text-gray-700 font-medium">Repetir tarea</span>
                        </label>
                        {isRecurring && (
                            <div className="mt-2 space-y-2">
                                <select
                                    value={recurrenceType}
                                    onChange={(e) => setRecurrenceType(e.target.value)}
                                    className="w-full p-1 border border-gray-200 rounded text-xs text-gray-600 focus:outline-none"
                                >
                                    <option value="daily">Cada día</option>
                                    <option value="weekly">Cada semana</option>
                                    <option value="monthly">Cada mes</option>
                                    <option value="yearly">Cada año</option>
                                    <option value="custom">Días específicos...</option>
                                </select>
                                {recurrenceType === "custom" && (
                                    <div className="flex gap-1 justify-between">
                                        {daysOfWeek.map(d => (
                                            <button
                                                key={d.id}
                                                type="button"
                                                onClick={() => toggleDay(d.id)}
                                                className={`w-6 h-6 text-[9px] font-bold rounded-full border ${recurrenceDays.includes(d.id) ? "bg-blue-600 text-white border-blue-700" : "bg-white text-gray-500 border-gray-200"}`}
                                            >
                                                {d.label}
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};
